import { get, post } from '../../utils/myFetch';

export async function getActiveList(params) {
  return get(`/middlecenter/service/apigateway/v3/jyNetActivityRest/page`, params);
}

export async function getActiveLive(params) {
  return get(`/middlecenter/service/apigateway/v3/jyNetActivityRest/pageForApp`, params);
}

export async function checkPermisson(params) {
  return get(`/middlecenter/service/apigateway/v3/tsWebRtc/conference`, params);
}

export async function behavioralRecord(params) {
  return post(
    `/middlecenterres/service/apigateway/api/v3/resLiveOperateRest/insertOrUpdate`,
    params,
  );
}

export async function liveInfo(params) {
  return get(
    `/middlecenter/service/apigateway/v3/jyNetActivityRest/infoForApp`,
    params,
  );
}
